import React, {useEffect, useState} from 'react';
import {useList} from "react-use";
import lodash from 'lodash'
import Checkbox from "../../../../../components/checkbox";

import {Collapse} from 'react-collapse';

function AtBat(props) {
    const [isOpened, setIsOpened] = useState(false);
    const {selected} = props;
    const [listAtBat, listAtBatHelper] = useList([
        {
            value: 1,
            name: '1打席目',
            checked: false,
        },
        {
            value: 2,
            name: '2打席目',
            checked: false,
        },
        {
            value: 3,
            name: '3打席目',
            checked: false,
        },
        {
            value: 4,
            name: '4打席目以降',
            checked: false,
        },
    ]);

    useEffect(() => {
        if(selected.length === 0) return;
        selected.map(item => {
            const index = listAtBat.findIndex(i => i.value === item);
            listAtBat[index].checked = true;
        })
    },[selected])
    useEffect(() => {
        props.onChange(lodash.map(lodash.filter(listAtBat,['checked', true]), 'value'));
    },[listAtBat]);

    const onChange = (item, index) => {
        listAtBatHelper.updateAt(index, {...item, checked: !item.checked});
    }

    return (
        <div className='inner-item-child group-filter-item'>
           <div className={'open-collapse'}>
               <div className='toggle-collapse' onClick={()=> setIsOpened(!isOpened)}>
                   <h4>試合内打席</h4>
                   <img src="/img/chevron_down_24px.svg" alt="arrow-down" style={{transform:isOpened === true && 'rotate(180deg)'}}/>
               </div>
               <Collapse isOpened={isOpened}>
                   <div className="search-group" >
                       {listAtBat.map((item,index) => {
                           return <div key={item.value} className={'search-main-advanced-checkbox'}>
                               <label>
                                   <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                   {item.name}
                               </label>
                           </div>
                       })}
                   </div>
               </Collapse>
           </div>
            <div className={'close-collapse'}>
                <div>
                    <h4>試合内打席</h4>
                </div>
                    <div className="search-group" >
                        {listAtBat.map((item,index) => {
                            return <div key={item.value} className={'search-main-advanced-checkbox'}>
                                <label>
                                    <Checkbox onChange={() => onChange(item, index)} value={item.value} checked={item.checked}/>
                                    {item.name}
                                </label>
                            </div>
                        })}
                    </div>
            </div>
        </div>
    )
}

export default AtBat;
